var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "place-picker" },
    [
      _c("app-input", {
        attrs: {
          name: "place-picker",
          required: _vm.required,
          type: "text",
          label: _vm.label,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("placePickerStarted")
          },
        },
        model: {
          value: _vm.value.title,
          callback: function ($$v) {
            _vm.$set(_vm.value, "title", $$v)
          },
          expression: "value.title",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }